import React from "react";

// Blue "script modifiable" editable field convention
export function BlueInput({ label, value, onChange, placeholder, testId, className = "", type = "text" }) {
  return (
    <label className="flex min-w-0 flex-col gap-1">
      {label && <span className="text-xs font-semibold text-slate-500 dark:text-slate-400">{label}</span>}
      <input
        type={type}
        data-testid={testId}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`blue-field h-11 w-full min-w-0 rounded-lg px-3 text-sm ${className}`}
      />
    </label>
  );
}

export function BlueTextarea({ label, value, onChange, placeholder, testId, rows = 3, className = "" }) {
  return (
    <label className="flex min-w-0 flex-col gap-1">
      {label && <span className="text-xs font-semibold text-slate-500 dark:text-slate-400">{label}</span>}
      <textarea
        data-testid={testId}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        className={`blue-field w-full min-w-0 rounded-lg px-3 py-2 text-sm leading-relaxed ${className}`}
      />
    </label>
  );
}
